import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {SESSION_ERROR_MESSAGE} from 'constants/session';
import {TRANSLATION_KEYS} from 'locale';
import {ErrorPage} from 'pages/Common';
import {ApiError} from 'types';

const T_KEYS = TRANSLATION_KEYS.AGENT_JOIN_SESSION_PAGE;
const T_KEYS_COMMON = TRANSLATION_KEYS.COMMON.SESSION;

type Props = {
    error: ApiError;
    hasOtherActiveSession?: boolean;
    unableJoinSession?: boolean;
    notAuthorized?: boolean;
    invalidScreenRecorder?: boolean;
    sessionMinutesLimitExceeded?: boolean;
}

export const JoinSessionError: React.FC<Props> = ({
    error, hasOtherActiveSession, unableJoinSession, notAuthorized, invalidScreenRecorder, sessionMinutesLimitExceeded
}: Props) => {
    const {t} = useTranslation();

    const errorMessage = useMemo(() => {
        const requestError = error?.response?.data?.errors?.[0];
        if (!error && !unableJoinSession && !hasOtherActiveSession && !notAuthorized) {
            return t(T_KEYS.INVALID_LINK_ERROR_MSG);
        } else if (notAuthorized) {
            return t(T_KEYS.AUTH_ERROR_MSG);
        } else if (requestError === SESSION_ERROR_MESSAGE.HAS_ACTIVE || hasOtherActiveSession) {
            return t(T_KEYS.HAS_ACTIVE_SESSION_ERROR_MSG);
        } else if (requestError === SESSION_ERROR_MESSAGE.SCREEN_RECORDER_REQUIRED || invalidScreenRecorder) {
            return t(T_KEYS.SCREEN_RECORDER_REQUIRED_ERROR_MSG);
        } else if (requestError === SESSION_ERROR_MESSAGE.IN_SESSION_MINUTES_LIMIT_IS_OVER || sessionMinutesLimitExceeded) {
            return t(T_KEYS_COMMON.LIMITS.IN_SESSION_MINUTES_LIMIT_IS_OVER);
        } else {
            return t(T_KEYS.ERROR_MSG);
        }
    }, [t, error, unableJoinSession, hasOtherActiveSession, notAuthorized, invalidScreenRecorder, sessionMinutesLimitExceeded]);

    return <ErrorPage message={errorMessage} showOpenDefaultPageButton />;
};